<template>
    <div v-for="(group, type) in templateGroups" :key="type">
        <div v-if="fetchMaterialsForGroup(group.uuid).length > 0" class="mb-20">
            <h2 class="mb-7 text-grind">
                {{ group.content.display_name }}
            </h2>
            <div
                class="mb-20 mt-2 grid grid-cols-1 gap-5 lg:grid-cols-[20%_1fr]"
            >
                <div class="grid self-start lg:place-items-center">
                    <StoryblokImage
                        :src="group.content.group_image.filename"
                        :alt="group.content.group_image.alt"
                        class="hidden h-40 w-40 object-contain lg:block xl:h-48 xl:w-48 2xl:h-56 2xl:w-56"
                        :image-width="224"
                        :image-height="224"
                        :quality="100"
                    />
                    <a
                        :href="
                            '/' + group.content.product_details_link.cached_url
                        "
                        target="_blank"
                        class="text-brew underline lg:mt-7"
                        >Product Details</a
                    >
                </div>
                <div>
                    <h5 class="mb-2 text-sm text-grind">MATERIALS</h5>
                    <TemplateMaterialRow
                        v-for="(material, key) in fetchMaterialsForGroup(
                            group.uuid,
                        )"
                        :key="key"
                        :material="material"
                        :setup-guide="group.content.setup_guide.filename"
                        :tolerance-form="group.content.tolerance_form.filename"
                    />
                </div>
            </div>
            <hr class="mt-2 w-full border-t border-grind-400" />
        </div>
    </div>
</template>
<script setup lang="ts">
import TemplateMaterialRow from '~/components/page-building/template-gallery/components/TemplateMaterialRow.vue';
import StoryblokImage from '~/components/StoryblokImage.vue';
import TemplateGroupType from '~/types/TemplateGroupType';
import TemplateAlgoliaResult from '~/types/TemplateAlgoliaResult';

const props = defineProps<{
    templateGroups: TemplateGroupType[];
    materials: TemplateAlgoliaResult[];
}>();

const materialPriorities = ['Standard'];
function fetchMaterialsForGroup(uuid): TemplateAlgoliaResult[] {
    return props.materials
        .filter((material) => material.storyblok_group_uuid === uuid)
        .sort((materialA, materialB) => {
            const indexA = materialPriorities.indexOf(materialA.material);
            const indexB = materialPriorities.indexOf(materialB.material);
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            }
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;

            return materialA.material.localeCompare(materialB.material);
        });
}
</script>
